'use client'

import Register from '../account/register'
import Login from '../account/login'
import { bagelFatOne } from '@/utilities/fontImport'
import { cn } from '@/utilities/ui'

const LoginTemplate = () => {
  return (
    <div className="w-full px-6 py-8 mt-12 lg:mt-24 mb-10">
      <div className="text-center mb-10">
        <h1 className={cn('text-3xl font-bold text-primary mb-2', bagelFatOne.className)}>
          Mon espace
        </h1>
        <p className="font-semibold text-primary/70 max-w-xl mx-auto">
          Connectez-vous ou créez un compte pour retrouver vos commandes, vos adresses et vos
          avantages.
        </p>
      </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto">
        <Login />
        <Register />
      </div>
    </div>
  )
}

export default LoginTemplate
